<a uiSref="discussioncategory" [uiParams]="{ categoryId: category.id }" [class.plain]="plain">{{ category.parent ? category.parent.name + ': ' : '' }}{{ category.name }}</a>
